import { Box } from '@givebutter/primitives/box';
import { ConnectDocuments } from '@stripe/react-connect-js';
import { StripeExpressProvider } from 'providers/StripeExpressProvider';

const PayoutsTaxDocuments = () => {
    return (
        <StripeExpressProvider>
            <Box>
                <ConnectDocuments />
            </Box>
        </StripeExpressProvider>
    );
};

export { PayoutsTaxDocuments };
